import { NgModule } from '@angular/core';

import { CommonUIModule } from '../common-ui';

import { TileComponent } from './tile';

@NgModule({
  declarations: [TileComponent],
  exports: [TileComponent],
  imports: [CommonUIModule],
})
export class TileModule {}
